import React from "react";

export const ScreenSelector = ({ screens, value, onChange }) => (
  <div className="mt-6">
    <label className="text-sm font-semibold text-black/70">Μέγεθος οθόνης</label>
    <div className="mt-3 grid gap-3 sm:grid-cols-3">
      {screens.map((s) => (
        <button
          key={s.id}
          type="button"
          data-testid={`calc-screen-${s.id}`}
          onClick={() => onChange(s.id)}
          className={`rounded-2xl border p-4 text-left transition-all ${
            value === s.id
              ? "border-brand-500 bg-brand-50/40 ring-1 ring-brand-500"
              : "border-black/10 bg-white hover:border-black/25"
          }`}
        >
          <div className="font-display text-2xl font-bold text-ink">{s.label}</div>
          <div className="mt-1 text-xs leading-snug text-black/55">{s.desc}</div>
        </button>
      ))}
    </div>
  </div>
);
